import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../styles/print.css";
import { 
  Printer, 
  Image, 
  Palette, 
  FileText,
  Gift,
  CreditCard,
  QrCode,
  Truck
} from "lucide-react";
import { useState } from "react";

export default function PrintSection() {
  const [activePrint, setActivePrint] = useState(0);
  
  const printServices = [
    {
      icon: <Image size={40} />,
      title: "Flyers & Brochures",
      description: "Design percutant pour vos campagnes marketing",
      color: "#3B82F6",
      colorRgb: "59, 130, 246",
      items: ["Flyers", "Dépliants", "Brochures", "Affiches"]
    },
    {
      icon: <FileText size={40} />,
      title: "Cartes & Papeterie",
      description: "Identité visuelle professionnelle",
      color: "#10B981",
      colorRgb: "16, 185, 129",
      items: ["Cartes visite", "En-têtes", "Factures", "Catalogues"]
    },
    {
      icon: <Gift size={40} />,
      title: "Packaging & Goodies",
      description: "Emballages créatifs et articles promotionnels",
      color: "#8B5CF6",
      colorRgb: "139, 92, 246",
      items: ["Packaging", "T-shirts", "Stickers", "Tote bags"]
    },
    {
      icon: <QrCode size={40} />,
      title: "Digital Print",
      description: "Solutions d'impression moderne",
      color: "#F59E0B",
      colorRgb: "245, 158, 11",
      items: ["QR Codes", "Réalité augmentée", "Impression variable"]
    }
  ];

  return (
    <section className="print-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Impression & Support Print</h2>
          <p className="section-subtitle">
            Donnez vie à votre marque avec nos solutions d'impression professionnelles
          </p>
        </div>
        
        <div className="print-content">
          <div className="print-grid">
            {printServices.map((service, index) => (
              <motion.button
                key={index}
                className={`print-tab ${activePrint === index ? 'active' : ''}`}
                onClick={() => setActivePrint(index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                style={{ 
                  '--color': service.color,
                  '--color-rgb': service.colorRgb
                }}
              >
                <div className="tab-icon" style={{ color: service.color }}>
                  {service.icon}
                </div>
                <div className="tab-content">
                  <h3 className="tab-title">{service.title}</h3>
                  <p className="tab-description">{service.description}</p>
                </div>
              </motion.button>
            ))}
          </div>
          
          <motion.div 
            key={activePrint}
            className="print-details"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="details-header">
              <h3 className="details-title">{printServices[activePrint].title}</h3>
              <div className="details-color" style={{ backgroundColor: printServices[activePrint].color }}></div>
            </div>
            
            <ul className="details-items">
              {printServices[activePrint].items.map((item, idx) => (
                <motion.li 
                  key={idx}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.05 }}
                >
                  <span className="item-check">✓</span>
                  {item}
                </motion.li>
              ))}
            </ul>
            
            <div className="details-features">
              <div className="feature">
                <Truck size={20} />
                <span>Livraison rapide</span>
              </div>
              <div className="feature">
                <Palette size={20} />
                <span>Design personnalisé</span>
              </div>
              <div className="feature">
                <CreditCard size={20} />
                <span>Devis gratuit</span>
              </div>
            </div>
            
            <Link to="/contact" className="details-button" style={{
              '--color': printServices[activePrint].color,
              '--color-rgb': printServices[activePrint].colorRgb
            }}>
              Demander un devis print
            </Link>
          </motion.div>
        </div>
        
        
      </div>
    </section>
  );
}